import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";

import { routeTree } from "./routeTree.gen";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
    },
  },
});

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: "intent",
  /*
   * Non-negotiable when using TanStack Query. Router keeps its own loader
   * cache which by default treats preloaded data as fresh for 30s; left at the
   * default you get two caches disagreeing. Zero makes Query's staleTime the
   * single source of truth.
   */
  defaultPreloadStaleTime: 0,
});

// This declaration is what makes Link and useNavigate type-safe.
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
